import type { UrlEntry, UrlRegion } from '@/types';

export const isIndexable = false;

export const urls: Record<'financingForm', Record<UrlRegion, UrlEntry>> = {
  financingForm: {
    de: 'finanzierung-form',
    'de-en': 'financing-form',
    es: 'formulario-financiacion',
    'es-en': 'financing-form',
    fr: 'formulaire-de-financement',
    'fr-en': 'financing-form',
    gb: 'financing-form',
    nl: 'financiering-formulier',
    'nl-en': 'financing-form',
    pt: 'formulario-de-financiamento',
    'pt-en': 'financing-form',
    us: 'financing-form',
    ww: 'financing-form',
  },
};
